var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-tag',{staticClass:"mb-2",class:['date-badge', 'mr-2', {'has-series': _vm.hasSeries}, {'no-series': !_vm.hasSeries}],attrs:{"title":_vm.date},on:{"remove":function($event){return _vm.$emit('badge-remove', _vm.index)}}})}
var staticRenderFns = []

export { render, staticRenderFns }